import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { AppStore } from 'src/app/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: false
})
export class ModalComponent implements OnInit {
  constructor(private modal: BciWkModalService, private appStore: AppStore) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '600px',
        overflowY: 'hidden',
      },
    });
  }

  hazteCliente() {
    window.parent.location.href = this.appStore.env.redirects.hazteCliente;
  }

  close() {
    this.modal.close();
  }
}
